import './App.css';
import { ConfigProvider } from 'antd';
import { BrowserRouter } from "react-router-dom";
import { store, persistor } from './redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import AppRouter from './AppRouter';
import viVN from 'antd/locale/vi_VN';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConfigProvider 
          theme={{ 
            token: { 
              colorPrimary: '#00b96b',
              borderRadius: 6
            } 
          }}
          locale={viVN}
        >
          <div className="App">
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
          </div>
        </ConfigProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;

